module.exports = __webpack_public_path__ + "static/media/Mehdi Nourbakhsh.e6904e4d.png";